import React, { Component } from 'react'
import { Button, Modal, Icon } from 'rsuite'

import { StyledConfirmModal, StyledButton } from '../styled/StyledQuestionComponents'
import AlertConfirmIcon from './Icons/AlertConfirmIcon';



class ModalConfirmStartQuestionary extends Component {
  constructor(props) {
    super(props) 
      this.state = {
          show: false
      }
   
  } 

  render() {
    return (
      <div className="modal-container">
        <StyledConfirmModal backdrop="static" show={this.props.showConfirmModal} onHide={() => this.props.closeConfirmModal()} size='xs'>
          <Modal.Body>
           <div className={'modal-body'}>
           <AlertConfirmIcon 
           width={60}
           />
               {
                   this.props.hasTimeLimit ?
                       <p>Este simulado tem <strong>limite de tempo.</strong> <br /> Tem certeza que deseja continuar?</p> :
                       <p>Deseja iniciar o simulado agora?</p>
               }
           </div>
          </Modal.Body>
          <Modal.Footer>
               <div className={'modal-footer'}>
                    <StyledButton
                     color={'green'} 
                     appearance="defaut"     
                     onClick={() => this.props.startQuestionary()}>
                    Iniciar simulado
                    </StyledButton>
                    <StyledButton          
                     appearance="ghost"     
                     onClick={() => this.props.closeConfirmModal()}>
                    Voltar depois
                    </StyledButton>
              </div>
          </Modal.Footer>
        </StyledConfirmModal>
      </div>
    );
  }
} 

export default ModalConfirmStartQuestionary



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/QuestionsNew/_components/ModalConfirmStartQuestionary.js